import React from 'react';
import { di } from 'react-magnetic-di';

import { KbSuggestedArticles as KnowledgeBaseSuggestedArticles } from 'view/common/fields/kb-suggestions';
import { Box } from '@atlaskit/primitives/box';

import { usePortalId } from '../../../controllers/request-create-context-provider';
import {
	useKnowledgeBaseArticles,
	useSummaryFieldId,
} from '../../../controllers/knowledge-base-suggestions-context-provider';
import type { KnowledgeBaseSuggestionFieldContainerProps } from './types';

export const KnowledgeBaseSuggestionFieldContainer = ({
	children,
	fieldId,
}: KnowledgeBaseSuggestionFieldContainerProps) => {
	di(useSummaryFieldId, useKnowledgeBaseArticles, usePortalId, KnowledgeBaseSuggestedArticles);

	const summaryFieldId = useSummaryFieldId();
	const knowledgeBaseArticles = useKnowledgeBaseArticles();
	const portalId = usePortalId();

	return (
		<Box paddingBlockStart="space.050">
			{children}
			{String(fieldId) === String(summaryFieldId) && knowledgeBaseArticles.length > 0 && (
				<KnowledgeBaseSuggestedArticles
					articles={knowledgeBaseArticles}
					connectedToForm
					portalId={portalId}
				/>
			)}
		</Box>
	);
};
